const translationIT = {
  'About Us': 'Riguardo a Noi',
  'MyCookAround is a new social platform and a market place, which connects Cooks and Guests according to sections, searching and location. The Cooks sell their farm products, warm homemade meals, homemade products, wine, fruits, vegetables, surpluses from their gardens but also experiences such as wine growing or cooking classes. MyCookAround connects people and brings economical benefits for the Cooks and the Guests.':
    'MyCookAround è una nuova piattaforma social e un mercato, che collega Cuochi e Ospiti in base a sezioni, ricerca e posizione. I cuochi vendono i loro prodotti agricoli, pasti caldi fatti in casa, prodotti fatti in casa, vino, frutta, verdura, eccedenze dai loro giardini ma anche esperienze come la viticoltura o lezioni di cucina. MyCookAround collega le persone e porta vantaggi economici per i Cuochi e gli Ospiti.',
  //FAQ Translation
  //1
  'How do I use MyCookAround?': 'Come posso usare MyCookAround?',
  //2
  'What are MyCookAround policies?': 'Quali sono le politiche di MyCookAround?',
  //3
  'Who can be a Cook?': 'Chi può essere un cuoco?',
  //4
  'What do I need to create a Cook’s profile?':
    'Di cosa ho bisogno per creare un profilo di Cuoco?',
  //5
  'What kind of photo should I upload in my profile?':
    'Che tipo di foto devo caricare nel mio profilo?',
  //6
  'When will my Offers go online?': 'Quando saranno online le mie offerte?',
  //7
  'What do I get for the membership I pay to MyCookAround?':
    ' Cosa ottengo per l`iscrizione che pago a MyCookAround?',
  //8
  'How many portions/events/items/kilograms can I sell?':
    'Quante porzioni / eventi / articoli / chilogrammi posso vendere?',
  //9
  'Do I have to sell only main courses as a home Cook?':
    'Devo vendere solo secondi piatti come Cuoco di casa?',
  //10
  'As a home Cook should I sell only one meal or serve the whole menu?':
    'Come cuoco di casa dovrei vendere solo un pasto o servire l`intero menu?',
  //11
  'As a home Cook What if I am not interested in social dining but I only want to sell meals?':
    'Che cosa succede se come Cuoco di casa non mi interessa la cena sociale ma vendo solo i miei pasti?',
  //12
  'What if I want to sell my Offers as a home Cook at my place but I only have limited time to spend with my Guests?':
    'Cosa succede se desidero vendere le mie offerte come Cuoco di casa a casa mia ma ho solo un tempo limitato da trascorrere con i miei Ospiti?',
  //13
  'How do I set the price?': 'Come posso impostare il prezzo?',
  //14
  'How much money can I make on MyCookAround as a Cook?':
    'Quanti soldi posso guadagnare su MyCookAround come Cuoco?',
  //15
  'As a Cook, how do I deal with Orders I get?':
    'Come Cuoco, come gestisco gli ordini che ottengo?',
  //16
  'Is there any way how I can increase my profit as a home Cook?':
    'C`è un modo in cui posso aumentare i miei profitti come Cuoco di casa?',
  //17
  'If I am paid via Platform MyCookAround and want to avoid unnecessary bank transfer fees, how do I do it?':
    'Se sono pagato tramite la piattaforma MyCookAround e desidero evitare spese di trasferimento bancario non necessarie, come posso farlo?',
  //1
  '<ol><li class="li1"><span class="s1">MyCookAround has the easiest possible manipulation. Even elderly people can manage. The User signs to be either a Cook or a Guest. Everyone can be both and switch in their account between Cook &lsquo;s and Guest &lsquo;s profile. Users can log in with an email address, Facebook account or Google account.</span></li><li class="li1"><span class="s1">You must fill all profile details, including a short introduction e.g. &ldquo;Farmer growing the best oranges&rdquo;, &ldquo;Stay at home mother who cooks for her family every day and takes pride in quality of ingredients and likes to meet new people&rdquo; or &ldquo; Single man who loves to cook but hates to eat alone&rdquo;, &bdquo;Farm growing the best organic chickens&ldquo;, and upload a profile picture.</span></li><li class="li1"><span class="s1">Then as a Cook you fill your payment details including payment threshold, in case you choose to be paid out via Platform MyCookAround. It is a tool that saves money on bank transfers where you set minimum amount to receive your pay outs. To receive money you also will be asked for a scan of your ID. Then you create your Offer (plus icon on Cook &lsquo;s profile) &ndash; it can be one portion of any meal you are cooking, several course menu, event, anything you prepare (homemade jam) or grow (one kilogram of oranges) at home or a cooking class where you offer the whole experience to your Guests. You have to upload a picture of your Offer, fill the description, set the price, how many portions/items/seats you have available, date and time of serving/taking place, estimated time of consumption, take away/eat with/both option and your Offer is online. If someone is interested in your Offer, you will get a notification either as a chat request or a direct Order. You can chat with your Guests about an additional questions regarding your Offer (when exactly they come etc.).</span></li><li class="li1"><span class="s1">As a Guest you set filters &ndash; distance from the place where you are located at the moment, price range, time, food restrictions, quantity and in case of meal constumptions if you want to eat with or take away. Also you can use key word search. Then MyCookAround gives you matches with the Offers and you can start browsing. The Offers you like you can easily directly Buy via MyCookAround, or cash at Cook&rsquo;s place or agree with the Cook on any suitable kind of an online payment.</span></li><li class="li1"><span class="s1">After Meal sharing/purchase/experience is due, you can rate under each profile of both Cooks and Guests, which builds trust in the community.</span></li><li class="li1"><span class="s1">When you see that a User on the other side is violating our Terms and Conditions, you can report them.</span></li></ol>':
    '<ol><li class="li1"><span class="s1">Utilizzare MyCookAround &egrave; davvero semplice. Anche le persone anziane possono farcela. L&rsquo;utente crea un suo profilo per essere un cuoco o un ospite. Chiunque pu&ograve; essere sia l&rsquo;uno che l&rsquo;altro e cambiare il proprio account tra il profilo di Cuoco e quello di Ospite. Gli utenti possono accedere con un indirizzo e-mail, un account Facebook o un account Google.</span></li><li class="li1"><span class="s1">Devi inserire tutti i dettagli del profilo, inclusa una breve introduzione, ad es. &ldquo;L&rsquo;agricoltore che coltiva le arance migliori&rdquo;, &ldquo;Casalinga che cucina ogni giorno per la sua famiglia ed &egrave; orgogliosa della qualit&agrave; degli ingredienti e ama incontrare nuove persone&rdquo; o &ldquo;Uomo single che ama cucinare ma odia mangiare da solo&rdquo;, &ldquo;Allevatore di ottimi polli biologici &ldquo;e carica una foto del profilo.</span></li><li class="li1"><span class="s1">Se sei iscritto come cuoco, inserisci i dettagli del metodo di pagamento che preferisci, inclusa la soglia di pagamento, nel caso in cui tu scelga di essere pagato tramite la piattaforma MyCookAround. &Egrave; uno strumento che consente di risparmiare denaro sui trasferimenti bancari in cui si imposta l&rsquo;importo minimo per ricevere i pagamenti. Per ricevere denaro ti verr&agrave; anche chiesto di scansionare il tuo ID. Quindi crei la tua offerta (icona pi&ugrave; sul profilo di Cook): pu&ograve; essere una porzione di qualsiasi pasto tu stia cucinando, diversi menu di portata, eventi, tutto ci&ograve; che prepari (marmellata fatta in casa) o coltivi (un chilo di arance) a casa o un corso di cucina in cui offri tutta l&rsquo;esperienza ai tuoi ospiti. Devi caricare una foto della tua offerta, compilare la descrizione, impostare il prezzo, il numero di porzioni / articoli / posti che metti a disposizione, data e ora di servizio / luogo, tempo stimato di consumo, portare via / mangiare con / entrambe le opzioni e la tua offerta &egrave; online. Se qualcuno &egrave; interessato alla tua offerta, riceverai una notifica come richiesta di chat o come ordine diretto. Puoi chattare con i tuoi ospiti per ulteriori domande sulla tua offerta (quando arrivano esattamente ecc.).</span></li><li class="li1"><span class="s1">Se sei iscritto come Ospite imposti i filtri: distanza dal luogo in cui ti trovi al momento, fascia di prezzo, tempo, restrizioni alimentari, quantit&agrave; e in caso di consumi alimentari se vuoi mangiare o portare via. Inoltre puoi usare la ricerca per parole chiave. Quindi MyCookAround ti d&agrave; i risultati con le offerte e puoi iniziare a navigare. Le offerte che ti piacciono possono facilmente essere acquistate direttamente tramite MyCookAround, oppure pagate in contanti al ritiro o essere concordate con il Cuoco circa il tipo di pagamento online pi&ugrave; adatto.</span></li><li class="li1"><span class="s1">Dopo aver scelto tra condivisione del pasto/ acquisto / condivisione esperienza, puoi valutare ciascun profilo di Cuochi e Ospiti, il che crea fiducia nella comunit&agrave;.</span></li><li class="li1"><span class="s1">Quando noti che un altro utente sta violando i nostri Termini e condizioni, puoi segnalarlo.</span></li></ol>',
  //2
  '<p>MyCookAround has a strict nondiscrimination policy. MyCookAround is at its core, an open community dedicated to bringing the world closer together by fostering meaningful, shared experiences among people from all parts of the world. Our community includes people from virtually every country on the globe. It is an incredibly diverse community, drawing together individuals of different cultures, values, and norms. The MyCookAround community is committed to building a world where people from every background feel welcome and respected, no matter how far they have traveled from home. This commitment rests on two foundational principles that apply both to MyCookArounds Cooks and Guests inclusion and respect. Our shared commitment to these principles enables every User to feel welcome on MyCookAround no matter who they are, where they come from, how they worship, or whom they love. MyCookAround Cooks welcome Guests of all backgrounds with authentic hospitality and open minds. Joining MyCookAround, as a Cook or Guest, means becoming part of a community of inclusion. Bias, prejudice, racism, and hatred have no place on our platform or in our community. While Cooks are required to follow all applicable laws that prohibit discrimination based on such factors as race, religion, national origin, and others listed below, we commit to do more than comply with the minimum requirements established by law.</p>': `<p>MyCookAround ha una rigorosa politica di non discriminazione. MyCookAround ha come obiettivo principale quello di creare una comunit&agrave; aperta, dedicata ad avvicinare il mondo, promuovendo esperienze significative e condivise tra persone provenienti da ogni angolo del pianeta. La nostra comunit&agrave; comprende persone provenienti da quasi tutti i paesi del mondo. &Egrave; una comunit&agrave; incredibilmente diversificata, che riunisce individui di culture, valori e norme differenti. <br />La comunit&agrave; MyCookAround &egrave; impegnata a costruire un mondo in cui le persone di ogni estrazione si sentano benvenute e rispettate, indipendentemente da quanto abbiano viaggiato da casa. Questo impegno si basa su due principi fondamentali che si applicano sia ai Cuochi che agli Ospiti di MyCookAround: inclusione e rispetto. Il nostro impegno condiviso verso questi principi consente a ogni Utente di sentirsi benvenuto su MyCookAround, indipendentemente da chi sia, da dove viene, dalla sua religione o inclinazione sessuale.  I Cuochi di MyCookAround accolgono gli Ospiti di ogni estrazione con un&rsquo;ospitalit&agrave; autentica e una mente aperta. Entrare a far parte di MyCookAround, come Cuoco o Ospite, significa entrare a far parte di una comunit&agrave; di inclusione. Distorsioni, pregiudizi, razzismo e odio non hanno posto sulla nostra piattaforma o nella nostra comunit&agrave;. Mentre i Cuochi sono tenuti a seguire tutte le leggi applicabili che vietano la discriminazione in base a fattori quali razza, religione, origine nazionale e altri elencati di seguito, ci impegniamo a fare di pi&ugrave; che rispettare i requisiti minimi stabiliti dalla legge.</p>`,
  //3
  '<p>All farmers, farms, all homemade food producers or anyone who cooks their meals at home can become a Cook of MyCookAround. Home Cooks can sell one portion of any meal as well a whole event of 5 course menu. Time does not matter. They can sell breakfasts, lunches, dinners or snacks. Also anyone who prepares any kind of food like homemade jams or cookies can sell them via MyCookAround. If you are a farmer grow your own products, MyCookAround is a perfect marketplace for you. If your cooking is really good and you feel confident enough to organize the whole cooking session, you can offer a cooking class. The only limit is the age. You must be over 18 years old.</p>':
  '<p>Tutti gli agricoltori, le fattorie, tutti i produttori di alimenti fatti in casa o chiunque cucini i propri pasti a casa pu&ograve; diventare un Cuoco di MyCookAround. I Cuochi casalinghi possono vendere una porzione di qualsiasi pasto e un intero evento di 5 portate. Il tempo non ha importanza. Possono vendere colazioni, pranzi, cene o spuntini. Anche chi prepara qualsiasi tipo di cibo come marmellate o biscotti fatti in casa pu&ograve; venderli tramite MyCookAround. Se sei un agricoltore, coltiva i tuoi prodotti, MyCookAround &egrave; il mercato perfetto per te. Se la tua cucina &egrave; davvero buona e ti senti abbastanza sicuro da organizzare l&rsquo;intera preparazione del pasto, puoi offrire un corso di cucina. L&rsquo;unico limite &egrave; l&rsquo;et&agrave;. Devi avere pi&ugrave; di 18 anni.</p>',
//4
  '<p> Only a smartphone, tablet, laptop or a PC to use the Platform. Creating of the profile is doable only via MyCookAround platform and takes approximately 10 minutes. </p>': `<p> Solo uno smartphone, un tablet, un laptop o un PC per utilizzare la piattaforma. La creazione del profilo è possibile solo tramite la piattaforma MyCookAround e richiede circa 10 minuti. </p>`,
  //5
  '<p> It has to be a genuine photo of yourself. As a farm, be it a pic of some of your farmers or he farm. As a private Cook, the best would be a picture in your kitchen when you are cooking or farm where you are working and mainly smiling. </p>': `<p> Deve essere una tua foto autentica. Se iscrivi una fattoria, inserisci una foto di alcuni dei tuoi agricoltori o della tua azienda. Se ti iscrivi come Cuoco privato, sarebbe meglio caricare una foto nella tua cucina quando cucini o dell’orto dove lavori quando coltivi ma principalmente una foto in cui sorridi.</p>`,
  //6
  '<p> Immediately. You don‘t have to wait for any approval. </p>':
    '<p>Subito. Non devi aspettare alcuna approvazione.</p>',
  //7
  '<p>A powerful, online presence. MyCookAround actively markets your Offers. A dedicated team verifies Guests reviews, making sure they are legitimate. This gives you credibility and helps future Guests make the decision to stay with you. 24/7 support is here for you and your Guests</p>': `<p> Una presenza online potente. MyCookAround commercializza attivamente le tue offerte. Un team dedicato verifica le recensioni degli Ospiti, assicurandosi che siano legittime. Questo ti dà credibilità e aiuta i futuri Ospiti a decidere di stare con te. L’assistenza 24/7 è qui per te e per i tuoi ospiti. </p>`,
  //8
  '<p> It totally depends on you. If you want to increase your sales as a home Cook, the best way is to have planned what you will cook on a specific day and to upload your Offer a few days in advance. If Guests buy fast, you can upload again and set higher amount of portions/seats at table/items available. It is important to find a good balance to have enough time to get ingredients and sell as much as possible in order not to have any waste. And of course the more Offers you upload, the more sales you will make. </p>': `<p>Dipende totalmente da te. Se vuoi aumentare le tue vendite come Cuoco a casa, il modo migliore è di pianificare ciò che cucinerai in un giorno specifico e caricare la tua offerta con qualche giorno di anticipo. Se gli Ospiti acquistano velocemente, è possibile caricare nuovamente e impostare un numero maggiore di porzioni / posti al tavolo / articoli disponibili. È importante trovare un buon equilibrio per avere abbastanza tempo per procurarsi gli ingredienti e vendere il più possibile per non sprecare. E naturalmente più offerte carichi, più vendite effettuerai.
    </p>`,
  //9
  '<p> Not at all. If you are good at baking, you can sell your homemade cookies. If you have time only in the morning, you can sell only breakfasts. If you make homemade jams or grow apples, you can sell them. If you want to spend time with your Guests and make more money, you can sell the whole event or a cooking experience. The only condition is homemade food or homemade product. </p>': `<p> Affatto. Se sei un bravo pasticcere, puoi vendere i tuoi biscotti fatti in casa. Se hai tempo solo al mattino, puoi vendere solo colazioni. Se produci marmellate fatte in casa o coltivi mele, puoi venderle. Se vuoi trascorrere del tempo con i tuoi Ospiti e guadagnare di più, puoi vendere l’intero evento o un’esperienza culinaria. L’unica condizione è che il cibo sia cucinato o prodotto in casa. </p>`,
  //10
  '<p> You have to find your balance. You can sell 5 course menu or just one meal or both at the same day. Actually the more Offers you create, the higher your sales will be. You can cook several courses and upload them together and also separately as different Offers. </p>': `<p> Devi trovare il tuo equilibrio. Puoi vendere un menu di 5 portate o solo un pasto o entrambi nello stesso giorno. In realtà, più offerte crei, maggiori saranno le tue vendite. Puoi cucinare diverse portate e caricarle insieme o anche venderle separatamente come offerte diverse. </p>`,
  //11
  '<p> Then you simply set a function “take away” in your Offers. In this case, please always have food containers. The recommendation of MyCookAround is to use paper boxes, which are recyclable. Also there are Guests who bring their own containers, which you can agree on in a chat. </p>': `<p> Imposta semplicemente la funzione “take away” nelle tue offerte. In questo caso, si prega di avere sempre contenitori per alimenti. La raccomandazione di MyCookAround è di usare scatole di carta, che sono riciclabili. Inoltre ci sono Ospiti che portano i propri contenitori, basta mettersi d’accordo in chat. </p>`,
  //12
  '<p> We have a function where you set your “estimated time of consumption” in every Offer upload. It is up to you if you want to limit the time you spend with your Guests or you want to keep it open. But be aware of a fact that the more time you spend with your Guests, the more you can charge for it. </p>': `<p> Abbiamo una funzione in cui si imposta il “tempo di consumo stimato” in ogni caricamento dell’offerta. Spetta a te stabilire se vuoi limitare il tempo da passare con i tuoi Ospiti o se vuoi tenerlo aperto. Ma fai attenzione al fatto che più tempo passi con i tuoi Ospiti, più è alto prezzo che puoi chiedere. </p>`,
  //13
  '<p> How you evaluate your Offers is up to you. If it is one meal Offer, we recommend to set the price per meal a little bit lower than restaurants sell the same meal for. For example, if “spaghetti carbonara” in your neighborhood is sold for 10 Euro, set your price to 8 Euro. If you are a farmer or homemade food producer, sell for the price you sell regularly.  </p>': `<p> Come valuti le tue offerte dipende da te. Se si tratta di un’offerta per un pasto, si consiglia di impostare il prezzo per pasto un po ‘più in basso rispetto a quello in cui i ristoranti vendono lo stesso pasto. Ad esempio: se gli “spaghetti alla carbonara” nel tuo quartiere vengono venduti per 10 euro, imposta il tuo prezzo a 8 euro. Se sei un agricoltore o un produttore di alimenti fatti in casa, vendi al prezzo che pratichi regolarmente.
    </p>`,
  //14
  '<p> If there is no regulation in your country that would limit income via online platforms, it totally depends on your activity and will. You can sell one meal per week just not to eat alone when you cook or you can make it your full time business and cook and sell or organize events everyday. If you like the concept of MyCookAround, you can make it your full time business. If you have already an ongoing registered business (farm, homemade food producer), MyCookAround will increase your sales significantly. </p>': `<p>Se nel tuo Paese non esiste una regolamentazione che limiti il reddito attraverso piattaforme online, dipende totalmente dalla tua attività e volontà. Puoi vendere un pasto a settimana solo per non mangiare da solo quando cucini o puoi renderlo il tuo business a tempo pieno e cucinare e vendere o organizzare eventi ogni giorno. Se ti piace il concetto di MyCookAround, puoi renderlo il tuo business a tempo pieno. Se hai già un’attività commerciale in corso (azienda agricola, produttore di alimenti fatti in casa), MyCookAround aumenterà in modo significativo le tue vendite.
    </p>`,
  //15
  '<p>When you get an Order from a Guest, you get an email notification to the email address you wrote in registration of your profile.</p>': `<p>Quando ricevi un Ordine da un Ospite, ricevi una notifica via email all&rsquo;indirizzo email che hai scritto nella registrazione del tuo profilo.</p>`,
  //16
  '<p> To increase your profits, it is good to follow pricing strategy based on anticipated demand. For instance, times of high demand may lead to higher Offer rates, in order to maximise revenue. When you see that you live in a tourist area and your Friday evening Offers disappear fast, why not make more of them and for a bit higher price? (We still recommend to be cheaper than a restaurant to attract more people). </p>': `<p> Per aumentare i profitti, è bene seguire la strategia dei prezzi basata sulla domanda anticipata. Ad esempio, i periodi di forte domanda possono comportare tassi di offerta più elevati, al fine di massimizzare le entrate. Quando vedi che vivi in una zona turistica e le tue offerte del venerdì sera scompaiono velocemente, perché non farne di più e per un prezzo leggermente più alto? (Raccomandiamo comunque di essere più economici di un ristorante per attirare più persone). </p>`,
  //17
  '<p>The best way is to set your payment threshold to a certain amount and you will get your payments after you reach it. If you don ‘t set the threshold, you will get your due pay out every Wednesday. </p>': `<p>Il modo migliore è impostare la soglia di pagamento su un determinato importo e riceverai i pagamenti dopo averlo raggiunto. Se non imposti la soglia, riceverai il pagamento dovuto ogni mercoledì.</p>`,

  //Profile translation
  SEARCH_FOR: 'Cerca...',
  'Became a Guest': `Diventa un Ospite`,
  'Became a Cook': `Diventa un Cuoco`,
  Profile: `Profilo`,
  'Payment Card': `Carta di Pagamento`,
  Settings: `Impostazioni`,
  Share: `Condividi`,
  'Bank Account': `Conto bancario`,
  Logout: `Disconnettersi`,
  'Contact Support': `Contatta il Sapporto`,
  'Contact Us': `Contattaci`,
  FAQ: 'FAQ',
  'Terms and Conditions': 'Termini a Condizioni',
  'Edit Profile': `Modifica Profilo`,
  'My Account': `Il mio account`,
  'Push Notifications': `Notifiche push`,
  'Sign out': `Disconnessione`,
  'Current Orders': `Ordini correnti`,
  'Past Orders': `Ordini passati`,
  'Newest First': `Prima i più nuovi`,
  Oldest: `il più vecchio`,
  'Filter by': `Filtra per`,
  'Have any question or need help?': `Hai domande o hai bisogno di aiuto?`,
  'Feel free to write us. We will answer you as soon as possible.': `Sentiti libero di scriverci. Le risponderemo il più presto possibile.`,
  Send: `Mandare`,
  'My Offer': `La mia offerta`,
  'User Reviews': `Recensioni degli utenti`,
  'Meal Details': `Dettagli del pasto`,
  'Order Details': `Dettagli dell'ordine`,
  'Cannot find offers': 'Impossibile trovare le offerte',
  'Searching Offers around': 'Ricerca di offerte in giro',
  Order: 'Ordini',
  Save: 'Salvare',
  'Currently you have no past orders':
    'Momentálně nemáte žádné předchozí objednávky',
  'Currently you have no orders': 'Attualmente non hai ordini',
  'Back to my orders': 'Torna ai miei ordini',
  'Waiting for Accept': 'In attesa di accettare',
  Refused: 'rifiutato',
  Ready: 'Pronto',
  'Ready in': 'Pronto in',
  ARRIVE_IN: 'Arrivare in',
  'per item': 'a articolo',
  Quantity: 'Quantità',
  Available: 'A disposizione',
  'Cooks Details': 'Dettagli di cucina',
  'Guests Details': 'Dettagli ospiti',
  'Take away': 'Porta via',
  'Eat with': 'Mangia con',
  Both: 'Tutti e due',
  'Total Price': 'Prezzo totale',
  'Your Payout': 'Il tuo pagamento',
  Cook: 'Cuoco',
  Guest: 'Ospite',
  Cooks: 'Cuochi',
  Guests: 'Ospiti',
  'Currently the cooks have no added offer':
    'Attualmente i cuochi non hanno alcuna offerta aggiuntiva',
  'Report cook': 'Segnala cuoco',
  'Report guest': 'Segnala ospite',
  Cancel: 'Annulla',
  'New Offer': 'Nuova offerta',
  General: 'Generale',
  'Number of items available': 'Il numero di Articoli disponibili',
  'Price per portion/item': 'Prezzo per porzione / articolo',
  'Date and Time': `La data e l’ora`,
  CONSUMPTION_TYPE_MESSAGE:
    'Il cibo è disponibile in loco, ossia l’ospite deve consumare nel luogo di preparazione',
  NO_OFFER_LISTED: 'Non hai ancora nessuna offerta',
  Done: 'Fatto',
  Category: 'Categoria',
  Select: 'Scelta',
  Name: 'Nome',
  Description: 'Descrizione',
  Restrictions: 'Limitazioni',
  'Type of Consumption': 'Tipo di consumo',
  TODAY: 'Oggi',
  YESTEDAY: 'Ieri',
  RATE_YOUR_GUEST: 'Assegna punti a tuo Ospite!',
  RATE_YOUR_COOK: 'Assegna punti a tuo Cuoco!',
  WRITE_A_NOTE: 'Scrivi una nota',
  CHANGE_PASSWORD: 'Cambia password',
  RESET_PASSWORD: 'Resetta la password',
  RESET_YOUR_PASSWORD: 'Resetujte své heslo',
  RESET_PASSWORD_SUCCESSFUL: 'La tua password è stata aggiornata con successo.',
  YOUR_EMAIL: `tua email`,
  WRITE_MESSAGE: 'Scrivi tuo messagio',
  DETAILS: 'Dettagli',
  ADD_OFFER: 'Aggiungi offerta',
  MEAL_NOT_EXISTS: 'Il pasto non esiste',
  DELETE: 'Elimina',
  DELETE_MESSAGE: 'Vuoi veramente cancellare questo pasto?',
  USERNAME: 'Nome utente',
  PHONE_NUMBER: 'Numero di telefono',
  STREET: 'Strada',
  CITY: 'Città',
  NOTE: 'Nota',
  ZIP_CODE: `CAP`,
  REGION: 'Regione',

  MY_ORDERS: 'Miei Ordini',
  MY_OFFERS: 'Mie Offerte',
  GO_TO_OFFERS: 'Vai sulle Mie Offerte',
  GO_TO_ORDERS: 'Vai sulle Miei Ordini',
  YOUR_OFFER: 'La tua offerta',
  WAS_DELETED: `è stata eliminata dall’Amministratore`,

  NOTIFICATIONS: 'Notificazione',
  NEW_ORDER: 'Nuovo ordine',
  ORDER_ACCEPTED_NOTIFICATION: 'Ordine accettato',
  ORDER_REFUSED_NOTIFICATION: 'Ordine rifiutato',
  NEW_ORDER_NOTIFICATION_MESSAGE: 'Hai una nuova richiesta d’ordine',
  OFFER_DELETED: 'Offerta eliminata',
  OFFER_DELETED_NOTIFICATION_MESSAGE:
    'La tua offerta è stata eliminata dall’Amministratore',
  Reason: 'Motivo',
  SWITCH_ACCOUNT_MESSAGE:
    'Si prega di cambiare account per visualizzare questo Ordine',

  //Modals
  ORDER_ACCEPTED: `Hai accettato l'ordine!`,
  Continue: 'Continua',
  ACCEPT: 'Accettare',
  REPORT_REASON: `Il tuo motivo è stato inviato all'ospite.`,
  'Write a reason of reporting': `Scrivi un motivo per segnalare`,
  REFUSE_ORDER: `Rifiuta l'ordine`,
  ACCEPTED_ORDER: 'Il tuo ordine è stato accettato!',
  PICKUP_ADDRESS: `Ritira il tuo ordine al seguente indirizzo all'indirizzo`,
  REFUSE_MESSAGE: 'Il tuo ordine è stato rifiutato!',
  ORDER_SENT: 'Il tuo ordine è stato inviato!',
  PROSSECCING_TO_COOK: 'Procedere al cuoco',
  SET_VISIBLE: 'Stai per impostare questo pasto come invisibile.',
  VISIBLE_MESSAGE: `Questo può essere utile, se sai che cucinerai il pasto più tardi in futuro
  e non voglio eliminarlo.`,
  DONT_SHOW_AGAIN: 'Non mostrare più',
  LOGIN_MODAL: 'Devi creare un account o effettuare il login per ordinare!',
  TAKE_A_MOMENT: 'Ci vorrà solo un momento.',
  NO_CHAT_MESSAGE: 'Non hai ancora nessun messaggio',
  OFFER_ORDER: 'Ordine',
  ADDRESS: 'Indirizzo',
  ADDRESS_NOTES: 'Nota (piano, numero di appartamento, etc.)',
  CONSTANT_OFFER: 'Offerta costante',
  Breakfast: 'Colazione',
  Lunch: 'Pranzo',
  Dinner: 'Cena',
  AVAILABLE_DATES: 'Date disponibili',
  VIEW_DATES: 'visualizzare le date disponibili',
  NO_DATES: 'nessuna data disponibile',
  TIME_SCHEDULE: 'Orario',
  NO_TIME_SCHEDULE: 'Nessun programma di tempo',
  'New Card': 'Nuova carta',

  NO_REVIEWS: 'Ancora nessuna recensione',
  'Sending Order': 'Ordine di invio',
  'Logging in': 'Entrando',
  'accepted order': 'ordine accettato',
  REPORT_MESSAGE:
    'Grazie per la tua segnalazione Lo esamineremo il prima possibile.',
  'Adding Report': 'Aggiunta di un rapporto',
  CREATE_PROFILE: 'Crea un profilo',
  // BUTTONS
  SEND_ORDER: 'Invia Ordine',
  NAVIGATE: 'Naviga',
  SKIP: 'Saltare',
  SUBMIT: 'Invia',
  'Signing you up': 'Ti sto iscrivendo',
  'Creating profile': 'Creare un profilo',

  // AUTHENTICATION
  CREATE_AN_ACCOUNT: 'Crea un Profile',
  OR_SIGN_IN: 'O accedi con',
  EMAIL_LOGIN: 'Accedi con email',
  FACEBOOK_LOGIN: 'Accedi con Facebook',
  GOOGLE_LOGIN: 'Accedi con Google',
  LOGIN: 'Accedi',
  PASSWORD: 'Password',
  PASSWORD_AGAIN: 'Ripeti la password',
  NAME: 'Nome',
  SURNAME: 'Cognome',
  CREATE_ACCOUNT: 'Crea un Account',
  CREATE: 'Crea',
  I_AGREE_WITH: `Sono d'accordo con`,
  TERMS_AND_CONDITIONS: 'Termini e Condizioni',
  FORGOT_PASSWORD: 'Password dimenticato',
  FORGOT_YOUR_PASSWORD: 'Hai dimenticato la password?',
  TO_RESET_PASSWORD:
    'Per reimpostare la password, inserisci la tua e-mail di seguito.',
  PASSWORD_SENT: 'La password è stata inviata alla tua e-mail.',
  ADMIN_LOGIN: 'Accedi come amministratore',
  CREATE_COOK_ACCOUNT: 'Crea un profilo Cuoco',
  CREATE_GUEST_ACCOUNT: 'Crea un profilo Ospite',
  COOKIES:
    'Per migliorare il nostro sito Web e fornirti servizi personalizzati, vorremmo memorizzare i cookie sul tuo dispositivo.',
  READ_MORE: 'Leggi di più.',
  IMAGE_NOTE: '*l`immagine dovrebbe avere una dimensione massima di 400 kb',

  //Welcome screen
  GUEST_DESCRIPTION: `Voglio comprare deliziosi piatti da vari cuochi`,
  COOK_DESCRIPTION: `Voglio vendere il mio menu e cucinarlo con amore per gli ospiti`,
  GUEST_BUY_DESCRIPTION: 'Voglio comprare',
  GUEST_SELL_DESCRIPTION: 'Voglio vendere',
  I_AM_GUEST: `Sono Ospite`,
  I_AM_COOK: `Sono Cuoco`,

  //Date Picker Weekdays
  Mo: 'Lu',
  Tu: 'Ma',
  We: 'Me',
  Th: 'Gi',
  Fr: 'Ve',
  Sa: 'Sa',
  Su: 'Do',
  //Date Picker Months
  January: 'Gennaio',
  February: 'Febbraio',
  March: 'Marzo',
  April: 'Aprile',
  May: 'Maggio',
  June: 'Giugno',
  July: 'Luglio',
  August: 'Agosto',
  September: 'Settembre',
  October: 'Ottobre',
  November: 'Novembre',
  December: 'Dicembre',

  //restriction
  'Dairy Free': 'Senza lattosio',
  'Gluten Free': 'Senza glutine',
  Halal: 'Halal',
  Kosher: 'Kosher',
  'Nut Free': 'Senza noce',
  Organic: 'Organico',
  Vegan: 'Vegan',
  Vegetarian: 'Vegetarian',
  'Low Carb': 'Low Carb',
  Fitness: 'Fitness',
  'Sugar Free': 'Senza zucchero',
  Paleo: 'Paleo',
  GENERAL: 'Senza limiti',

  //ERROR HANDLER
  INPUT_FIRST_NAME: 'Si prega compilare tuo nome!',
  INPUT_LAST_NAME: 'Si prega compilare tuo cognome!',
  INPUT_USERNAME: 'Si prega compilare tuo nome dell’utente!',
  INPUT_DESCRIPTION: 'Si prega compilare tua descrizione!',
  INPUT_PHONE_NUMBER: 'Si prega compilare tuo numero di telefono!',
  INPUT_STREET: 'Si prega compilare tuo indirizzo!',
  INPUT_CITY: 'Si prega compilare la citta!',
  TIME_ERROR: 'Ci vuole più tempo di quanto preventivato.',
  CONSUMPTION_ERROR: 'Seleziona l’articolo da consumare',
  DATE_ERROR: 'Seleziona la data e l’ora',
  IMAGE_UPLOAD_ERROR: 'Si prega di caricare un’immagine',
  MEAL_NAME_ERROR: 'Si prega di inserire il nome del pasto!',
  MEAL_DESCRIPTION_ERROR: 'Si prega di compilare la descrizione del pasto!',
  PRICE_ERROR: 'Si prega di inserire il prezzo',
  RESCTRICTED_MESSAGE: 'Hai inserito alcune parole riservate.',

  // SUCCESS HANDLER
  'Profile Updated': 'Profile aggiornato',
  'Something went wrong': 'Qualcosa è andato storto',

  //meal filter
  'Meal Filter': 'Filtro pasto',
  Filter: 'Filtro',
  LOCATION: 'Locazione',
  NEAREST: 'Più vicino',
  FROM: 'Da',
  TO: 'A',
  SET: 'Impostare',
  MAX_PRICE: 'Mass prezzo',

  //update profile
  EDIT_PROFILE_HEADER_COOK: 'Crea profilo come cuoco',
  EDIT_PROFILE_HEADER_GUEST: 'Crea profilo come ospite',

  //edit meal
  'Edit Offer': 'Modifica offerta',
  'Editing Offer': 'Offerta di modifica',
  MAX_TIME: 'Tempo massimo',
  //Edit meal error
  FILL_TITLE: 'Si prega di inserire il nome del pasto!',
  FILL_DESCRIPTION: 'Si prega di compilare la descrizione del pasto!',
  FILL_PRICE: 'Si prega di inserire il prezzo',

  // PRODUCT CATEGORIES
  'Jams and marmelades': 'Confetture e marmellate',
  'Dried fruits and vegetables': 'Frutta candita e verdure disidratate',
  'Fresh fruits and vegetables': 'Frutta e verdura fresca',
  'Pickled fruits and vegetables': 'Frutta e verdura conservata',
  'Legumes(beans, lents...etc.)': 'Legumi',
  Mushrooms: 'Funghi',
  'Fruit syrups and lemonade': 'Sciroppi e limonata alla frutta',

  'Cakes and sweets': 'Torte e dolci',
  Puddings: 'Budino',
  Chocolate: 'Cioccolato',
  'Ice creams': 'Gelato',
  'Bakery products and pastry': 'Prodotti di panetteria',

  'Diary products(butter, cheese, milk, yogurt...etc.)': 'Latticini',
  Honey: 'Miele',
  Oils: 'Oli',
  Eggs: 'Uova',

  Grains: 'Grani',
  'Seeds, cereals and nuts': 'Semi, cereali, frutta secca',
  'Spices and Seasonings': 'Spezie e condimenti',
  'Tea and herbal tea': 'Tè e tisane',
  Herbs: 'Erbe',
  'Herbal syrups and lemonade': 'Sciroppi e limonata alle erbe',

  'Smoked meats, hams and sausages': 'Carni affumicate, prosciutti e salsicce',
  'Pesto, sauce and dressings': 'Pesto, salsa e condimenti',

  'Beer, vino and destillate': 'Birra, vino e bevande spiritose',

  'Ready meals': 'Pasti pronti',

  Appetizers: 'Aperitivi',
  'Bread spread': 'Pane spalmatto',
  Pasta: 'Pasta',
  'Pizza and focaccia': 'Pizza e focaccia',
  'Fish, sea fruit and shellfish': 'Pesce e frutti di mare',
  'Meat, steaks and venison': 'Carne, bistecche e carne di cervo',
  'Steamed food': 'Cibo al vapore',
  'Grilled and charcoaled food': 'Cibo alla griglia',
  'Roasted food': 'Cibo arrosto',
  Salads: 'Insalate',
  Soups: 'Minestre',

  'Home made natural products': 'Prodotti naturali fatti in casa',
  'Home made tinctures': 'Tinture fatte in casa',

  Experience: 'Esperienza',

  'Pet food': 'Cibo per animali',

  // CARDS AND BANK DETAILS
  PAYMENT_CARD: 'Carta di pagamento',
  NEW_CARD: 'Nuova carta',
  BANK_ACCOUNT: 'Conto bancario',
  NEW_ACCOUNT: 'Nuovo conto',
  ACCOUNT_DETAILS: 'Dettagli di conto',

  CARD_DETAILS: 'Dettagli carta',
  CARD_NUMBER: 'Numero di carta',
  CARDHOLDER_NAME: 'Nome del titolare',
  IBAN: 'IBAN',
  ACCOUNT_NUMBER: 'Numero di conto',
  SWIFT_CODE: `SWIFT Codice/BIC`,
  BANK_NAME: 'Nome della banca',
  BANK_ADDRESS: 'Indirizzo della banca',

  INVALID_CARD_NUMBER: 'Numero di carta non valido',
  INVALID_CARD_EXPIRATION: 'Data di scadenza della carta non valida',
  INVALID_CVV: 'CVV carta non valido',

  EMPTY_PAYMENT_CARDS: `Non hai aggiunto alcuna carta.`,
  EMPTY_BANK_ACCOUNT: `Non hai aggiunto un account.`,
  DELETE_THIS_CARD: 'Vuoi veramente cancellare questa carta?',
  PAYMENT_THRESHOLD: 'Soglia di pagamento',
  PAYMENT_THRESHOLD_MESSAGE: `Riceverai il pagamento quando l'importo dovuto supera la soglia specificata.`,

  INPUT_HOLDERS_NAME: `Inserisci il nome del titolare!`,
  INPUT_ACCOUNT_NUMBER: `Inserisci il numero di conto!`,
  INPUT_IBAN: 'Inserisci IBAN!',
  INPUT_SWIFT_CODE: 'Inserisci il codice SWIFT / BIC!',
  INPUT_BANK_NAME: 'Inserisci il nome della banca!',
  INPUT_BANK_ADDRESS: 'Inserisci l’indirizzo della banca!',
  INPUT_PAYMENT_THRESHOLD: 'Inserisci la Soglia di Pagamento!',

  //Change Password
  STAY_LOGGED: 'Rimani connesso',
  CURRENT_PASSWORD: 'Password attuale',
  NEW_PASSWORD: 'Nuova password',
  PASSWORD_INVALID: 'La password attuale non è valida.',
  PASSWORD_CHARACTERS: 'La password deve contenere almeno 6 caratteri.',
};
export default translationIT;
